module.exports = __webpack_public_path__ + "static/img/博览财经服务.34f87c0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/博览财经服务.gif
// module id = funD
// module chunks = 3